import { DTOError } from './DTOError';

export default DTOError;
